import type { BoundingBox, Bounds } from '@/version-types';

/**
 * 将位置和尺寸表示的包围盒转换为四向边界。
 *
 * @param box - 需要转换的包围盒。
 * @returns 与输入覆盖相同区域的四向边界。
 */
export const toBounds = (box: BoundingBox): Bounds => ({
    left: box.left,
    top: box.top,
    right: box.left + box.width,
    bottom: box.top + box.height,
});

/**
 * 将四向边界转换为位置和尺寸表示的包围盒。
 *
 * @param bounds - 需要转换的四向边界。
 * @returns 与输入覆盖相同区域的包围盒。
 */
export const toBoundingBox = (bounds: Bounds): BoundingBox => ({
    left: bounds.left,
    top: bounds.top,
    width: bounds.right - bounds.left,
    height: bounds.bottom - bounds.top,
});

/**
 * 合并任意数量的可选边界。
 *
 * @param boundsList - 需要合并的边界；空值不会参与计算。
 * @returns 同时覆盖全部有效输入的最小边界；没有有效输入时返回 null。
 */
export const unionBounds = (...boundsList: Array<Bounds | null | undefined>): Bounds | null => {
    let result: Bounds | null = null;

    boundsList.forEach((bounds) => {
        // 空值表示调用方当前没有可见区域，不能参与极值计算。
        if (!bounds) return;
        if (!result) {
            result = bounds;
            return;
        }
        result = {
            left: Math.min(result.left, bounds.left),
            top: Math.min(result.top, bounds.top),
            right: Math.max(result.right, bounds.right),
            bottom: Math.max(result.bottom, bounds.bottom),
        };
    });

    return result;
};
